import { render, staticRenderFns } from "./RecentlyAdded.vue?vue&type=template&id=75427a6a&scoped=true"
import script from "./RecentlyAdded.vue?vue&type=script&lang=js"
export * from "./RecentlyAdded.vue?vue&type=script&lang=js"
import style0 from "./RecentlyAdded.vue?vue&type=style&index=0&id=75427a6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75427a6a",
  null
  
)

export default component.exports